import { render, staticRenderFns } from "./BrandTe.vue?vue&type=template&id=ce11de58&scoped=true&"
import script from "./BrandTe.vue?vue&type=script&lang=js&"
export * from "./BrandTe.vue?vue&type=script&lang=js&"
import style0 from "./BrandTe.vue?vue&type=style&index=0&id=ce11de58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce11de58",
  null
  
)

export default component.exports